var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "page_Container" } }, [
    _c("div", { staticClass: "page" }, [
      _c(
        "div",
        { staticClass: "main-container", attrs: { id: "main-container" } },
        [
          _vm.activity.activityCurrentStatus !== 3
            ? _c("div", { ref: "box", staticClass: "box" }, [
                _c("div", { staticClass: "cBox" }, [
                  _c(
                    "h4",
                    { staticClass: "boxH4" },
                    _vm._l(_vm.preferentialConfigList, function(item) {
                      return _c("span", { key: item }, [_vm._v(_vm._s(item))])
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("p", { staticClass: "cp" }, [
                    _vm._v(
                      "\n                        活动时间：" +
                        _vm._s(_vm.activity.activityTimeRange) +
                        "\n                    "
                    )
                  ])
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activity.activityCurrentStatus !== 3
            ? _c("div", { staticClass: "list" }, [
                _vm.productBaseInfoList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "listleft" },
                      _vm._l(_vm.activityDetails.productBaseInfoList, function(
                        item,
                        index
                      ) {
                        return index % 2 === 0
                          ? _c("van-col", { key: item, staticClass: "ffBg" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.toDetails(item)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "imgBox" }, [
                                    _c("img", {
                                      attrs: { src: item.image, alt: "" }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p1" }, [
                                    _vm._v(
                                      _vm._s(item.name) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p2" }, [
                                    _c("span", [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(
                                            _vm.ESVBase.numberTofixed(
                                              item.minPrice
                                            )
                                          )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productBaseInfoList.length > 0
                  ? _c(
                      "div",
                      { staticClass: "listright" },
                      _vm._l(_vm.activityDetails.productBaseInfoList, function(
                        item,
                        index
                      ) {
                        return index % 2 === 1
                          ? _c("van-col", { key: item, staticClass: "ffBg" }, [
                              _c(
                                "div",
                                {
                                  on: {
                                    click: function($event) {
                                      _vm.toDetails(item)
                                    }
                                  }
                                },
                                [
                                  _c("div", { staticClass: "imgBox" }, [
                                    _c("img", {
                                      attrs: { src: item.image, alt: "" }
                                    })
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p1" }, [
                                    _vm._v(
                                      _vm._s(item.name) +
                                        "\n                            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("p", { staticClass: "p2" }, [
                                    _c("span", [
                                      _vm._v(
                                        "¥" +
                                          _vm._s(
                                            _vm.ESVBase.numberTofixed(
                                              item.minPrice
                                            )
                                          )
                                      )
                                    ])
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      }),
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.productBaseInfoList.length <= 0
                  ? _c("div", { staticClass: "kBox" }, [
                      _c("img", { attrs: { src: _vm.noProductUrl, alt: "" } }),
                      _vm._v(" "),
                      _c("p", [_vm._v("暂无商品！")])
                    ])
                  : _vm._e()
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.activity.activityCurrentStatus === 3
            ? _c("div", { staticClass: "gBox" }, [
                _c("img", { attrs: { src: _vm.noActivityUrl, alt: "" } }),
                _vm._v(" "),
                _c("p", [_vm._v("活动已过期！")])
              ])
            : _vm._e()
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }